class Transformer {
    deviceType= "transformer";
    code= "";
    description= "";
    manufacturer= "";
    weight= 0;
    height= 0;
    width= 0;
    depth= 0;

    power= 0; //power kW
    vin = 380; //Input voltage - connected to inverter 
    vout = 220; //Output voltage - connected to the grid
    

    unit = "peça (s)";
    product = { 
      price:0,
      cost:0,
      // taxes:0,
      sellerId:"", //Now its a string
      available:true, //editted by the user
       unit : "peça (s)",
      quantity:0

   };

    constructor() {
    };
  
    calc(){
   
    };

    
    loadFromOld(i){

      if(i._id){
        //alert(JSON.stringify(m._id))
        this.id = i._id.$oid;
      }else{
        alert(JSON.stringify(i._id))
        
      }

      this.deviceType = "transformer";
      this.code = i.codigo;
      this.description = i.descricao;
      this.manufacturer = i.fabricante;
      
      this.weight = i.peso;
      this.height = i.altura;
      this.width = i.largura;
      this.depth = i.profundidade;

      this.power = i.potenciaAc;
      
              
      this.product.priceTarget = i.precoTarget;
      this.product.cost = i.custo; 
      this.product.sellerId = i.fabricante;
      this.product.crmId=i.ploomesId;
      this.product.erpId = i.codRef;

      
      this.product.we  = {};
      this.product.we.ativoFranquia= i.ativoFranquia;
      this.product.we.ativoIntegrador = i.ativoIntegrador;
      this.product.we.ativoMatriz= i.ativoMatriz;
      if(i.custoUsdAtivo){
          this.product.we.custoUsdAtivo = i.custoUsdAtivo;
      this.product.we.custoUsd= i.custoUs;
      this.product.we.precoTargetUsd = i.precoTargetUsd;
      }
    }

    //calular inversor
}




export default Transformer;
